/* =============================================================================
   SILO 3 — SEGUROS EN TARRAGONA
   -----------------------------------------------------------------------------
   CÓMO FUNCIONA ESTE ARCHIVO

   Todo el contenido de la categoría de seguros vive aquí. No hay que tocar
   ningún componente .vue para añadir, editar o quitar una página.

   Para añadir una página comercial nueva:
     1. Copia un bloque entero de "servicios" (desde { hasta },)
     2. Cambia el slug, el grupo y el contenido en es: y ca:
     3. Pon publicada: true cuando el texto esté terminado

   IMPORTANTE — publicada:
     publicada: false  →  la página NO existe: no tiene URL, no sale en el
                          sitemap y no se enlaza desde ningún sitio.
     publicada: true   →  se genera la URL, entra en el sitemap y aparece
                          en la página de categoría.

     Publica solo cuando el contenido esté escrito de verdad. Una página con
     texto de relleno posiciona peor que una página que no existe, y arrastra
     al resto del silo.

   GUÍA RÁPIDA DE LOS CAMPOS SEO
     titleSeo     · 50-60 caracteres. Es el titular azul en Google.
                    Formato: [Acción + keyword] | Gestoría Riola
     description  · 140-160 caracteres. No posiciona, pero decide el clic.
                    Termina con una llamada a la acción.
     h1           · Uno por página. Puede parecerse al title pero no repetirlo.
     kwPrincipal  · La búsqueda que quieres ganar con esta página.
     kwLongTail   · Variantes que debes ir colocando de forma natural en el
                    texto. No las fuerces: si no encajan, sobran.

   ESTRUCTURA DE "secciones"
     Cada sección es un H2. Dentro puedes poner:
       parrafos: []  · texto normal
       lista: []     · lista con viñetas
       destacado: '' · frase resaltada en un recuadro (opcional)
   ============================================================================= */

module.exports = {
  id: 'seguros',
  icono: 'mdi-shield-check-outline',

  // URL de la categoría: /seguros  y  /cat/assegurances
  slug: { es: 'seguros', ca: 'assegurances' },

  /* Etiqueta corta para menús y footer. El h1 completo no cabe en el lateral. */
  tituloMenu: { es: 'Seguros', ca: 'Assegurances' },

  // Los seguros se atienden por el WhatsApp de Alex
  whatsappPropio: true,

  /* ===========================================================================
     PÁGINA DE CATEGORÍA (la página SILO)
     Su trabajo no es vender un seguro concreto: es explicar el servicio,
     capturar la búsqueda genérica "seguros en Tarragona" y repartir autoridad
     hacia las páginas comerciales de abajo.
     ======================================================================== */
  categoria: {
    es: {
      titleSeo: 'Seguros en Tarragona | Correduría — Gestoría Riola',
      description:
        'Comparamos entre varias aseguradoras y te damos el seguro que te conviene, no el que nos conviene. Hogar, coche, vida, empresa y transporte en Tarragona.',
      h1: 'Seguros en Tarragona',
      kwPrincipal: 'seguros en Tarragona',
      kwLongTail: [
        'correduría de seguros en Tarragona',
        'comparador de seguros Tarragona',
        'agente de seguros Tarragona',
        'contratar seguro en Tarragona'
      ],

      entradilla:
        'No trabajamos para una aseguradora. Trabajamos para ti. Comparamos las condiciones de varias compañías y te explicamos, en castellano y sin letra pequeña, cuál te conviene y por qué.',

      secciones: [
        {
          h2: 'Qué significa que seamos correduría y no agencia',
          parrafos: [
            'Una agencia vende los productos de una sola compañía. Una correduría compara los de varias y está obligada legalmente a asesorarte de forma objetiva. La diferencia se nota el día que tienes un siniestro y necesitas que alguien esté de tu lado.',
            'Cuando nos pides un presupuesto, pedimos precio a varias aseguradoras con las mismas coberturas y te enseñamos la comparativa. Tú decides con la información delante.'
          ],
          destacado:
            'El presupuesto es gratuito y no te compromete a nada. Si el seguro que ya tienes es mejor que lo que te ofrecemos, te lo diremos.'
        },
        {
          h2: 'Qué seguros gestionamos',
          parrafos: [
            'Empezamos por donde llevamos toda la vida: el vehículo. Coche, moto, ciclomotor, furgoneta o la flota entera de la empresa. Es el seguro que más movemos, y no por casualidad: muchos clientes llegan con una transferencia o una matriculación y salen también con la póliza resuelta.',
            'A partir de ahí cubrimos las tres áreas que más nos piden en Tarragona: la vida del particular, el negocio del autónomo y la actividad del transportista profesional.'
          ],
          lista: [
            'Vehículos: coche, moto, ciclomotor, furgoneta y flotas',
            'Particular: hogar, vida, salud y decesos',
            'Autónomos y empresa: responsabilidad civil, multirriesgo de comercio y convenio colectivo',
            'Transporte profesional: mercancías y responsabilidad civil del transportista'
          ],
          destacado:
            'Si acabas de comprar un coche, podemos darte el seguro y hacer la transferencia a la vez. Sales con el vehículo a tu nombre y asegurado el mismo día.'
        },
        {
          h2: 'Y si tienes un siniestro, no te dejamos solo',
          parrafos: [
            'Esta es la parte que nadie te cuenta cuando contratas por internet. Un parte mal redactado o una comunicación fuera de plazo pueden costarte la indemnización.',
            'Nosotros tramitamos el siniestro por ti: hablamos con la compañía, revisamos el peritaje y reclamamos si la valoración no es correcta. Sin coste adicional, porque ya está incluido en ser cliente nuestro.'
          ]
        },
        {
          h2: 'Por qué combinar seguros y gestoría en el mismo sitio',
          parrafos: [
            'Llevamos desde 1935 gestionando trámites de vehículos y transporte en Tarragona. Cuando alguien nos trae la transferencia de un coche, ya sabemos qué coche es, qué uso le va a dar y qué necesita asegurar.',
            'Ese contexto no lo tiene un comparador online. Por eso muchos clientes acaban trayéndonos también el seguro del negocio, el de la casa y el de la flota.'
          ]
        }
      ],

      faqs: [
        {
          q: '¿Cuánto cuesta que me hagáis un presupuesto?',
          a: 'Nada. Comparar y presentarte las opciones es gratuito y no te obliga a contratar. Solo cobramos cuando contratas, y lo paga la aseguradora, no tú.'
        },
        {
          q: '¿Tengo que ir a la oficina para contratar?',
          a: 'No. Puedes hacerlo entero por WhatsApp: nos mandas los datos, te enviamos la comparativa y firmas de forma digital. Si prefieres venir a Rambla Nova, también.'
        },
        {
          q: 'Ya tengo un seguro con otra compañía, ¿podéis revisarlo?',
          a: 'Sí, y es lo primero que recomendamos. Mándanos la póliza actual y te decimos qué estás pagando de más o qué coberturas te faltan. Si está bien, te lo diremos igual.'
        },
        {
          q: '¿Con qué aseguradoras trabajáis?',
          a: 'Trabajamos con varias compañías del mercado español. Cuál te conviene depende del riesgo concreto que quieras cubrir, y eso lo vemos caso por caso.'
        },
        {
          q: '¿Podéis asegurar la flota de mi empresa de transporte?',
          a: 'Sí. Es una de nuestras especialidades, porque llevamos también las tarjetas de transporte y la documentación de esos mismos vehículos.'
        }
      ],

      ctaTitulo: '¿Quieres saber si estás pagando de más?',
      ctaTexto:
        'Mándanos tu póliza actual por WhatsApp y te decimos qué te sobra y qué te falta. Sin compromiso.',
      ctaWhatsapp: 'Hola, quiero que me reviséis un seguro / me hagáis un presupuesto'
    },

    ca: {
      titleSeo: 'Assegurances a Tarragona | Corredoria — Gestoria Riola',
      description:
        'Comparem entre diverses asseguradores i et donem l\'assegurança que et convé, no la que ens convé. Llar, cotxe, vida, empresa i transport a Tarragona.',
      h1: 'Assegurances a Tarragona',
      kwPrincipal: 'assegurances a Tarragona',
      kwLongTail: [
        'corredoria d\'assegurances a Tarragona',
        'comparador d\'assegurances Tarragona',
        'agent d\'assegurances Tarragona',
        'contractar assegurança a Tarragona'
      ],

      entradilla:
        'No treballem per a una asseguradora. Treballem per a tu. Comparem les condicions de diverses companyies i t\'expliquem, en català i sense lletra petita, quina et convé i per què.',

      secciones: [
        {
          h2: 'Què vol dir que siguem corredoria i no agència',
          parrafos: [
            'Una agència ven els productes d\'una sola companyia. Una corredoria compara els de diverses i està obligada legalment a assessorar-te de manera objectiva. La diferència es nota el dia que tens un sinistre i necessites que algú estigui del teu costat.',
            'Quan ens demanes un pressupost, demanem preu a diverses asseguradores amb les mateixes cobertures i t\'ensenyem la comparativa. Tu decideixes amb la informació al davant.'
          ],
          destacado:
            'El pressupost és gratuït i no et compromet a res. Si l\'assegurança que ja tens és millor que el que t\'oferim, t\'ho direm.'
        },
        {
          h2: 'Quines assegurances gestionem',
          parrafos: [
            'Comencem per on portem tota la vida: el vehicle. Cotxe, moto, ciclomotor, furgoneta o la flota sencera de l\'empresa. És l\'assegurança que més movem, i no per casualitat: molts clients arriben amb una transferència o una matriculació i surten també amb la pòlissa resolta.',
            'A partir d\'aquí cobrim les tres àrees que més ens demanen a Tarragona: la vida del particular, el negoci de l\'autònom i l\'activitat del transportista professional.'
          ],
          lista: [
            'Vehicles: cotxe, moto, ciclomotor, furgoneta i flotes',
            'Particular: llar, vida, salut i decessos',
            'Autònoms i empresa: responsabilitat civil, multirisc de comerç i conveni col·lectiu',
            'Transport professional: mercaderies i responsabilitat civil del transportista'
          ],
          destacado:
            'Si acabes de comprar un cotxe, et podem fer l\'assegurança i la transferència alhora. Surts amb el vehicle al teu nom i assegurat el mateix dia.'
        },
        {
          h2: 'I si tens un sinistre, no et deixem sol',
          parrafos: [
            'Aquesta és la part que ningú t\'explica quan contractes per internet. Un comunicat mal redactat o una comunicació fora de termini et poden costar la indemnització.',
            'Nosaltres tramitem el sinistre per tu: parlem amb la companyia, revisem el peritatge i reclamem si la valoració no és correcta. Sense cost addicional, perquè ja està inclòs en ser client nostre.'
          ]
        },
        {
          h2: 'Per què combinar assegurances i gestoria al mateix lloc',
          parrafos: [
            'Fa des del 1935 que gestionem tràmits de vehicles i transport a Tarragona. Quan algú ens porta la transferència d\'un cotxe, ja sabem quin cotxe és, quin ús li donarà i què necessita assegurar.',
            'Aquest context no el té un comparador en línia. Per això molts clients acaben portant-nos també l\'assegurança del negoci, la de la casa i la de la flota.'
          ]
        }
      ],

      faqs: [
        {
          q: 'Quant costa que em feu un pressupost?',
          a: 'Res. Comparar i presentar-te les opcions és gratuït i no t\'obliga a contractar. Només cobrem quan contractes, i ho paga l\'asseguradora, no tu.'
        },
        {
          q: 'He d\'anar a l\'oficina per contractar?',
          a: 'No. Ho pots fer tot per WhatsApp: ens envies les dades, t\'enviem la comparativa i signes digitalment. Si prefereixes venir a Rambla Nova, també.'
        },
        {
          q: 'Ja tinc una assegurança amb una altra companyia, la podeu revisar?',
          a: 'Sí, i és el primer que recomanem. Envia\'ns la pòlissa actual i et diem què estàs pagant de més o quines cobertures et falten. Si està bé, t\'ho direm igualment.'
        },
        {
          q: 'Amb quines asseguradores treballeu?',
          a: 'Treballem amb diverses companyies del mercat espanyol. Quina et convé depèn del risc concret que vulguis cobrir, i això ho veiem cas per cas.'
        },
        {
          q: 'Podeu assegurar la flota de la meva empresa de transport?',
          a: 'Sí. És una de les nostres especialitats, perquè portem també les targetes de transport i la documentació d\'aquests mateixos vehicles.'
        }
      ],

      ctaTitulo: 'Vols saber si estàs pagant de més?',
      ctaTexto:
        'Envia\'ns la teva pòlissa actual per WhatsApp i et diem què et sobra i què et falta. Sense compromís.',
      ctaWhatsapp: 'Hola, vull que em reviseu una assegurança / em feu un pressupost'
    }
  },

  /* ===========================================================================
     GRUPOS
     Sirven para agrupar visualmente las tarjetas dentro de la página SILO.
     ======================================================================== */
  grupos: [
    {
      id: 'particular',
      es: { titulo: 'Para ti y para tu familia', subtitulo: 'Lo que quieres tener cubierto y no pensar más en ello' },
      ca: { titulo: 'Per a tu i per a la teva família', subtitulo: 'El que vols tenir cobert i no pensar-hi més' }
    },
    {
      id: 'empresa',
      es: { titulo: 'Para autónomos y empresas', subtitulo: 'Lo que la ley te exige y lo que te salva el negocio' },
      ca: { titulo: 'Per a autònoms i empreses', subtitulo: 'El que la llei t\'exigeix i el que et salva el negoci' }
    },
    {
      id: 'transporte',
      es: { titulo: 'Para el transporte profesional', subtitulo: 'Nuestra especialidad desde hace cuatro generaciones' },
      ca: { titulo: 'Per al transport professional', subtitulo: 'La nostra especialitat des de fa quatre generacions' }
    }
  ],

  /* ===========================================================================
     PÁGINAS COMERCIALES
     ======================================================================== */
  servicios: [

    /* ---------------------------------------------------------------------
       EJEMPLO COMPLETO Nº 1 — usa este como modelo para escribir los demás
       URL: /seguros/hogar-tarragona
       ------------------------------------------------------------------ */
    {
      slug: { es: 'hogar-tarragona', ca: 'llar-tarragona' },
      grupo: 'particular',
      icono: 'mdi-home-outline',
      publicada: true,

      es: {
        titleSeo: 'Contratar seguro de hogar en Tarragona | Gestoría Riola',
        description:
          'Comparamos el seguro de hogar de varias aseguradoras y te decimos cuál cubre de verdad lo que necesitas. Presupuesto gratis en Tarragona por WhatsApp.',
        h1: 'Contratar seguro de hogar en Tarragona',
        kwPrincipal: 'seguro de hogar en Tarragona',
        kwLongTail: [
          'contratar seguro de hogar en Tarragona',
          'seguro de hogar barato Tarragona',
          'comparar seguros de hogar Tarragona',
          'seguro de hogar para piso de alquiler Tarragona',
          'seguro de hogar con responsabilidad civil Tarragona'
        ],

        resumen:
          'Continente, contenido y responsabilidad civil. Comparamos varias compañías y te explicamos qué cubre cada una de verdad.',

        entradilla:
          'El seguro de hogar es el que más gente contrata sin leer y el que más disgustos da cuando llega el siniestro. Nosotros te enseñamos la comparativa de varias aseguradoras y te explicamos qué cubre cada póliza antes de que firmes nada.',

        secciones: [
          {
            h2: 'Qué cubre realmente un seguro de hogar',
            parrafos: [
              'Casi todas las pólizas hablan de tres cosas, y conviene saber qué significa cada una porque de ahí sale el precio y de ahí salen los problemas:'
            ],
            lista: [
              'Continente: la estructura de la vivienda. Paredes, suelos, instalaciones, puertas y ventanas. Si eres propietario, esto tiene que estar bien valorado.',
              'Contenido: todo lo que hay dentro. Muebles, electrodomésticos, ropa, ordenadores. Aquí es donde más gente se queda corta.',
              'Responsabilidad civil: lo que pasa si tu avería daña a un tercero. Una fuga que inunda al vecino de abajo entra por aquí, y suele ser la cobertura que más se usa.'
            ],
            destacado:
              'El error más común en Tarragona: asegurar el continente por el precio de compra del piso. El continente es lo que costaría reconstruirlo, no lo que pagaste por él. Si lo inflas, pagas de más todos los años y no cobras más.'
          },
          {
            h2: 'Las coberturas que la gente descubre tarde',
            parrafos: [
              'Estas no vienen siempre incluidas y son las que marcan la diferencia entre una póliza barata y una póliza que sirve:'
            ],
            lista: [
              'Daños por agua y localización de la avería: buscar la fuga puede costar más que repararla.',
              'Asistencia en el hogar 24 horas, con manitas incluido para pequeñas reparaciones.',
              'Robo fuera del domicilio y uso fraudulento de tarjetas.',
              'Rotura de cristales, vitrocerámica y encimeras.',
              'Daños eléctricos en electrodomésticos por subidas de tensión.',
              'Defensa jurídica en conflictos con la comunidad o con el arrendador.'
            ]
          },
          {
            h2: 'Si el piso es de alquiler',
            parrafos: [
              'Aquí hay una confusión constante. El propietario asegura el continente. El inquilino asegura el contenido y su responsabilidad civil.',
              'Si eres inquilino y no tienes nada contratado, una fuga tuya que dañe al vecino la pagas de tu bolsillo. Y si eres propietario y solo aseguras el continente, los daños que cause tu inquilino no están cubiertos por tu póliza.',
              'Cada vez más contratos de alquiler en Tarragona exigen que el inquilino acredite un seguro de responsabilidad civil. Si te lo han pedido y no sabes qué contratar, dínoslo y te preparamos exactamente eso.'
            ]
          },
          {
            h2: 'Cómo lo hacemos nosotros',
            parrafos: [
              'Nos dices los metros de la vivienda, si eres propietario o inquilino, y si hay algo de valor especial que quieras cubrir. Con eso pedimos precio a varias aseguradoras con las mismas coberturas, para que la comparación sea real y no un truco de letra pequeña.',
              'Te mandamos la comparativa por WhatsApp, te explicamos las diferencias y decides tú. Si al final resulta que la póliza que ya tienes es mejor, te lo diremos y no te venderemos nada.'
            ]
          },
          {
            h2: 'Y el día que tengas un siniestro',
            parrafos: [
              'Nos llamas a nosotros, no a un teléfono 900. Damos el parte, hacemos el seguimiento con la compañía y, si el perito valora por debajo de lo que corresponde, reclamamos. Está incluido en ser cliente nuestro.'
            ]
          }
        ],

        faqs: [
          {
            q: '¿Cuánto cuesta un seguro de hogar en Tarragona?',
            a: 'Depende de los metros, de si eres propietario o inquilino y de las coberturas. Para un piso medio en Tarragona ciudad la horquilla habitual va de 150 a 350 euros al año. Te damos el precio exacto de varias compañías sin compromiso.'
          },
          {
            q: '¿Puedo cambiar de seguro de hogar antes de que venza?',
            a: 'Puedes no renovarlo avisando con al menos un mes de antelación a la fecha de vencimiento. Nosotros nos encargamos de mandar la carta de baja y de que no haya ni un día sin cobertura.'
          },
          {
            q: 'Tengo el seguro con el banco de la hipoteca, ¿estoy obligado?',
            a: 'La ley te obliga a tener asegurado el continente si tienes hipoteca, pero no te obliga a contratarlo con el banco. Puedes llevarlo donde quieras. Suele ser de lo que más se ahorra al cambiar.'
          },
          {
            q: '¿Cubre los daños si se me inunda el piso del vecino?',
            a: 'Sí, eso entra por la responsabilidad civil. Es la cobertura que más se usa y conviene mirar bien el límite contratado, porque en algunas pólizas baratas se queda muy corto.'
          },
          {
            q: '¿Y si trabajo desde casa?',
            a: 'Díselo a quien te haga la póliza. Muchos seguros de hogar excluyen la actividad profesional, y si tienes equipo de trabajo en casa puede quedarse fuera de cobertura. Hay pólizas que lo contemplan.'
          }
        ],

        relacionados: ['coche-tarragona', 'vida-tarragona', 'responsabilidad-civil-tarragona'],

        ctaTitulo: 'Pídenos el presupuesto de tu seguro de hogar',
        ctaTexto:
          'Dinos los metros de tu vivienda y si eres propietario o inquilino. Te mandamos la comparativa de varias compañías por WhatsApp.',
        ctaWhatsapp: 'Hola, quiero un presupuesto de seguro de hogar en Tarragona'
      },

      ca: {
        titleSeo: 'Contractar assegurança de llar a Tarragona | Gestoria Riola',
        description:
          'Comparem l\'assegurança de llar de diverses asseguradores i et diem quina cobreix de veritat el que necessites. Pressupost gratis a Tarragona per WhatsApp.',
        h1: 'Contractar assegurança de llar a Tarragona',
        kwPrincipal: 'assegurança de llar a Tarragona',
        kwLongTail: [
          'contractar assegurança de llar a Tarragona',
          'assegurança de llar barata Tarragona',
          'comparar assegurances de llar Tarragona',
          'assegurança de llar per a pis de lloguer Tarragona'
        ],

        resumen:
          'Continent, contingut i responsabilitat civil. Comparem diverses companyies i t\'expliquem què cobreix cadascuna de veritat.',

        entradilla:
          'L\'assegurança de llar és la que més gent contracta sense llegir i la que més disgustos dona quan arriba el sinistre. Nosaltres t\'ensenyem la comparativa de diverses asseguradores i t\'expliquem què cobreix cada pòlissa abans que signis res.',

        secciones: [
          {
            h2: 'Què cobreix realment una assegurança de llar',
            parrafos: [
              'Gairebé totes les pòlisses parlen de tres coses, i convé saber què significa cadascuna perquè d\'aquí surt el preu i d\'aquí surten els problemes:'
            ],
            lista: [
              'Continent: l\'estructura de l\'habitatge. Parets, terres, instal·lacions, portes i finestres. Si ets propietari, això ha d\'estar ben valorat.',
              'Contingut: tot el que hi ha a dins. Mobles, electrodomèstics, roba, ordinadors. Aquí és on més gent es queda curta.',
              'Responsabilitat civil: el que passa si la teva avaria danya un tercer. Una fuita que inunda el veí de sota entra per aquí, i sol ser la cobertura que més s\'utilitza.'
            ],
            destacado:
              'L\'error més comú a Tarragona: assegurar el continent pel preu de compra del pis. El continent és el que costaria reconstruir-lo, no el que vas pagar. Si l\'infles, pagues de més cada any i no cobres més.'
          },
          {
            h2: 'Les cobertures que la gent descobreix tard',
            parrafos: [
              'Aquestes no vénen sempre incloses i són les que marquen la diferència entre una pòlissa barata i una pòlissa que serveix:'
            ],
            lista: [
              'Danys per aigua i localització de l\'avaria: buscar la fuita pot costar més que reparar-la.',
              'Assistència a la llar 24 hores, amb manetes inclòs per a petites reparacions.',
              'Robatori fora del domicili i ús fraudulent de targetes.',
              'Trencament de vidres, vitroceràmica i taulells.',
              'Danys elèctrics en electrodomèstics per pujades de tensió.',
              'Defensa jurídica en conflictes amb la comunitat o amb l\'arrendador.'
            ]
          },
          {
            h2: 'Si el pis és de lloguer',
            parrafos: [
              'Aquí hi ha una confusió constant. El propietari assegura el continent. El llogater assegura el contingut i la seva responsabilitat civil.',
              'Si ets llogater i no tens res contractat, una fuita teva que danyi el veí la pagues de la teva butxaca. I si ets propietari i només assegures el continent, els danys que causi el teu llogater no estan coberts per la teva pòlissa.',
              'Cada cop més contractes de lloguer a Tarragona exigeixen que el llogater acrediti una assegurança de responsabilitat civil. Si te l\'han demanat i no saps què contractar, digues-nos-ho i et preparem exactament això.'
            ]
          },
          {
            h2: 'Com ho fem nosaltres',
            parrafos: [
              'Ens dius els metres de l\'habitatge, si ets propietari o llogater, i si hi ha alguna cosa de valor especial que vulguis cobrir. Amb això demanem preu a diverses asseguradores amb les mateixes cobertures, perquè la comparació sigui real i no un truc de lletra petita.',
              'T\'enviem la comparativa per WhatsApp, t\'expliquem les diferències i decideixes tu. Si al final resulta que la pòlissa que ja tens és millor, t\'ho direm i no et vendrem res.'
            ]
          },
          {
            h2: 'I el dia que tinguis un sinistre',
            parrafos: [
              'Ens truques a nosaltres, no a un telèfon 900. Donem el comunicat, fem el seguiment amb la companyia i, si el pèrit valora per sota del que correspon, reclamem. Està inclòs en ser client nostre.'
            ]
          }
        ],

        faqs: [
          {
            q: 'Quant costa una assegurança de llar a Tarragona?',
            a: 'Depèn dels metres, de si ets propietari o llogater i de les cobertures. Per a un pis mitjà a Tarragona ciutat la forquilla habitual va de 150 a 350 euros l\'any. Et donem el preu exacte de diverses companyies sense compromís.'
          },
          {
            q: 'Puc canviar d\'assegurança de llar abans que venci?',
            a: 'Pots no renovar-la avisant amb almenys un mes d\'antelació a la data de venciment. Nosaltres ens encarreguem d\'enviar la carta de baixa i que no hi hagi ni un dia sense cobertura.'
          },
          {
            q: 'Tinc l\'assegurança amb el banc de la hipoteca, hi estic obligat?',
            a: 'La llei t\'obliga a tenir assegurat el continent si tens hipoteca, però no t\'obliga a contractar-lo amb el banc. El pots portar on vulguis. Sol ser del que més s\'estalvia en canviar.'
          },
          {
            q: 'Cobreix els danys si inundo el pis del veí?',
            a: 'Sí, això entra per la responsabilitat civil. És la cobertura que més s\'utilitza i convé mirar bé el límit contractat, perquè en algunes pòlisses barates es queda molt curt.'
          },
          {
            q: 'I si treballo des de casa?',
            a: 'Digues-ho a qui et faci la pòlissa. Moltes assegurances de llar exclouen l\'activitat professional, i si tens equip de treball a casa pot quedar fora de cobertura. Hi ha pòlisses que ho contemplen.'
          }
        ],

        relacionados: ['coche-tarragona', 'vida-tarragona', 'responsabilidad-civil-tarragona'],

        ctaTitulo: 'Demana\'ns el pressupost de la teva assegurança de llar',
        ctaTexto:
          'Digues-nos els metres del teu habitatge i si ets propietari o llogater. T\'enviem la comparativa de diverses companyies per WhatsApp.',
        ctaWhatsapp: 'Hola, vull un pressupost d\'assegurança de llar a Tarragona'
      }
    },

    /* ---------------------------------------------------------------------
       EJEMPLO COMPLETO Nº 2 — el que conecta con el silo de transporte
       URL: /seguros/mercancias-tarragona
       ------------------------------------------------------------------ */
    {
      slug: { es: 'mercancias-tarragona', ca: 'mercaderies-tarragona' },
      grupo: 'transporte',
      icono: 'mdi-package-variant-closed',
      publicada: true,

      es: {
        titleSeo: 'Seguro de mercancías en Tarragona | Gestoría Riola',
        description:
          'Seguro de mercancías transportadas y RC del transportista en Tarragona. Sabemos qué cubre el CMR y qué no. Presupuesto sin compromiso por WhatsApp.',
        h1: 'Seguro de mercancías en Tarragona',
        kwPrincipal: 'seguro de mercancías Tarragona',
        kwLongTail: [
          'seguro de mercancías transportadas Tarragona',
          'seguro para transportistas en Tarragona',
          'seguro CMR transporte internacional Tarragona',
          'seguro de mercancías para autónomo transportista'
        ],

        resumen:
          'Lo que llevas en el camión no está cubierto por el seguro del camión. Te explicamos la diferencia y te lo aseguramos bien.',

        entradilla:
          'El seguro del vehículo cubre el camión. La mercancía que va dentro es otra cosa completamente distinta, y es donde más transportistas descubren tarde que no estaban cubiertos.',

        secciones: [
          {
            h2: 'La confusión que cuesta dinero',
            parrafos: [
              'Mucha gente cree que el seguro a todo riesgo del camión cubre la carga. No la cubre. Son dos pólizas diferentes que responden a dos riesgos diferentes.',
              'Y hay una segunda distinción que también genera problemas: no es lo mismo el seguro de la mercancía (lo contrata el propietario de la carga) que la responsabilidad civil del transportista (la contratas tú, y cubre tu responsabilidad como porteador).'
            ],
            destacado:
              'Si tu cliente te pide un certificado de seguro de mercancías y le enseñas la póliza del camión, no te va a servir. Son cosas distintas y cada vez lo revisan más.'
          },
          {
            h2: 'Los límites del CMR y por qué no bastan',
            parrafos: [
              'El Convenio CMR fija la responsabilidad del transportista internacional por kilo de mercancía perdida o dañada. En transporte nacional, la Ley del Contrato de Transporte Terrestre fija un límite parecido.',
              'El problema es que esos límites se calculan por peso, no por valor. Un palé de componentes electrónicos pesa poco y vale mucho: si se pierde, el límite legal cubre una fracción de lo que realmente valía, y la diferencia te la reclaman a ti.',
              'Por eso existe la cobertura de valor declarado, que se contrata por encima del límite legal cuando transportas mercancía cara.'
            ]
          },
          {
            h2: 'Qué cubrimos',
            lista: [
              'Responsabilidad civil del transportista, nacional e internacional (CMR).',
              'Seguro de mercancías transportadas por daño, robo o pérdida total.',
              'Valor declarado por encima de los límites legales para carga de alto valor.',
              'Mercancía en depósito y durante las operaciones de carga y descarga.',
              'Responsabilidad civil de explotación de la empresa de transporte.',
              'Defensa jurídica y reclamación de daños frente a terceros.'
            ]
          },
          {
            h2: 'Lo que suele quedar excluido y conviene mirar',
            parrafos: [
              'Antes de firmar, revisa siempre estos puntos, porque son los que generan casi todas las discusiones cuando hay un siniestro:'
            ],
            lista: [
              'Mercancías peligrosas (ADR): normalmente requieren cobertura específica.',
              'Transporte frigorífico: la rotura de cadena de frío se excluye salvo pacto expreso.',
              'Vehículo desatendido o estacionado fuera de recinto vigilado: muchas pólizas no cubren el robo en esa situación.',
              'Mal estibado o embalaje deficiente por parte del cargador.',
              'Retrasos en la entrega: la responsabilidad por demora no siempre entra.'
            ]
          },
          {
            h2: 'Por qué te lo hacemos nosotros',
            parrafos: [
              'Llevamos las tarjetas de transporte, las capacitaciones y el CAP de buena parte de los transportistas de Tarragona. Cuando nos pides un seguro de mercancías, ya sabemos qué flota tienes, qué autorizaciones llevas y qué tipo de carga mueves.',
              'Eso significa que no te vamos a vender una póliza genérica de comparador. Te vamos a preguntar qué transportas, a dónde y para quién, y a partir de ahí buscamos.'
            ]
          }
        ],

        faqs: [
          {
            q: '¿El seguro del camión no cubre ya la mercancía?',
            a: 'No. El seguro del vehículo cubre el vehículo y los daños a terceros que provoques circulando. La carga que llevas dentro necesita su propia póliza.'
          },
          {
            q: 'Soy autónomo con un solo camión, ¿me hace falta?',
            a: 'Si transportas mercancía de terceros, sí. Tu responsabilidad como porteador existe igual tengas uno o cincuenta camiones, y cada vez más cargadores lo exigen por contrato antes de darte carga.'
          },
          {
            q: '¿Qué diferencia hay entre el seguro de mercancías y la RC del transportista?',
            a: 'El seguro de mercancías cubre el valor de la carga. La RC del transportista cubre tu responsabilidad legal si esa carga se daña por tu causa. Lo habitual es contratar la RC, y añadir mercancías cuando el cliente lo pide o la carga es de mucho valor.'
          },
          {
            q: '¿Cubre el transporte internacional?',
            a: 'Sí, si contratas la modalidad CMR. Hay que declarar los países por los que circulas, porque el ámbito geográfico se pacta en la póliza.'
          },
          {
            q: '¿Podéis asegurar toda la flota en una sola póliza?',
            a: 'Sí. Para flotas es lo habitual y suele salir más barato que asegurar vehículo a vehículo. Cuéntanos cuántos vehículos son y lo miramos.'
          }
        ],

        relacionados: ['flotas-camiones-tarragona', 'rc-transportista-tarragona', 'responsabilidad-civil-tarragona'],

        ctaTitulo: '¿Transportas mercancía de terceros?',
        ctaTexto:
          'Dinos qué transportas y con cuántos vehículos. Te preparamos la cobertura que de verdad necesitas, sin pagar por lo que no usas.',
        ctaWhatsapp: 'Hola, quiero información sobre el seguro de mercancías'
      },

      ca: {
        titleSeo: 'Assegurança de mercaderies a Tarragona | Gestoria Riola',
        description:
          'Assegurança de mercaderies transportades i RC del transportista a Tarragona. Sabem què cobreix el CMR i què no. Pressupost sense compromís per WhatsApp.',
        h1: 'Assegurança de mercaderies a Tarragona',
        kwPrincipal: 'assegurança de mercaderies Tarragona',
        kwLongTail: [
          'assegurança de mercaderies transportades Tarragona',
          'assegurança per a transportistes a Tarragona',
          'assegurança CMR transport internacional Tarragona',
          'assegurança de mercaderies per a autònom transportista'
        ],

        resumen:
          'El que portes al camió no està cobert per l\'assegurança del camió. T\'expliquem la diferència i t\'ho assegurem bé.',

        entradilla:
          'L\'assegurança del vehicle cobreix el camió. La mercaderia que va a dins és una altra cosa completament diferent, i és on més transportistes descobreixen tard que no estaven coberts.',

        secciones: [
          {
            h2: 'La confusió que costa diners',
            parrafos: [
              'Molta gent creu que l\'assegurança a tot risc del camió cobreix la càrrega. No la cobreix. Són dues pòlisses diferents que responen a dos riscos diferents.',
              'I hi ha una segona distinció que també genera problemes: no és el mateix l\'assegurança de la mercaderia (la contracta el propietari de la càrrega) que la responsabilitat civil del transportista (la contractes tu, i cobreix la teva responsabilitat com a portador).'
            ],
            destacado:
              'Si el teu client et demana un certificat d\'assegurança de mercaderies i li ensenyes la pòlissa del camió, no li servirà. Són coses diferents i cada cop ho revisen més.'
          },
          {
            h2: 'Els límits del CMR i per què no basten',
            parrafos: [
              'El Conveni CMR fixa la responsabilitat del transportista internacional per quilo de mercaderia perduda o danyada. En transport nacional, la Llei del Contracte de Transport Terrestre fixa un límit semblant.',
              'El problema és que aquests límits es calculen per pes, no per valor. Un palet de components electrònics pesa poc i val molt: si es perd, el límit legal cobreix una fracció del que realment valia, i la diferència te la reclamen a tu.',
              'Per això existeix la cobertura de valor declarat, que es contracta per damunt del límit legal quan transportes mercaderia cara.'
            ]
          },
          {
            h2: 'Què cobrim',
            lista: [
              'Responsabilitat civil del transportista, nacional i internacional (CMR).',
              'Assegurança de mercaderies transportades per dany, robatori o pèrdua total.',
              'Valor declarat per damunt dels límits legals per a càrrega d\'alt valor.',
              'Mercaderia en dipòsit i durant les operacions de càrrega i descàrrega.',
              'Responsabilitat civil d\'explotació de l\'empresa de transport.',
              'Defensa jurídica i reclamació de danys davant de tercers.'
            ]
          },
          {
            h2: 'El que sol quedar exclòs i convé mirar',
            parrafos: [
              'Abans de signar, revisa sempre aquests punts, perquè són els que generen gairebé totes les discussions quan hi ha un sinistre:'
            ],
            lista: [
              'Mercaderies perilloses (ADR): normalment requereixen cobertura específica.',
              'Transport frigorífic: la ruptura de cadena de fred s\'exclou llevat de pacte exprés.',
              'Vehicle desatès o estacionat fora de recinte vigilat: moltes pòlisses no cobreixen el robatori en aquesta situació.',
              'Mal estibat o embalatge deficient per part del carregador.',
              'Retards en el lliurament: la responsabilitat per demora no sempre hi entra.'
            ]
          },
          {
            h2: 'Per què t\'ho fem nosaltres',
            parrafos: [
              'Portem les targetes de transport, les capacitacions i el CAP de bona part dels transportistes de Tarragona. Quan ens demanes una assegurança de mercaderies, ja sabem quina flota tens, quines autoritzacions portes i quin tipus de càrrega mous.',
              'Això vol dir que no et vendrem una pòlissa genèrica de comparador. Et preguntarem què transportes, on i per a qui, i a partir d\'aquí busquem.'
            ]
          }
        ],

        faqs: [
          {
            q: 'L\'assegurança del camió no cobreix ja la mercaderia?',
            a: 'No. L\'assegurança del vehicle cobreix el vehicle i els danys a tercers que provoquis circulant. La càrrega que portes a dins necessita la seva pròpia pòlissa.'
          },
          {
            q: 'Sóc autònom amb un sol camió, em cal?',
            a: 'Si transportes mercaderia de tercers, sí. La teva responsabilitat com a portador existeix igual tinguis un o cinquanta camions, i cada cop més carregadors ho exigeixen per contracte abans de donar-te càrrega.'
          },
          {
            q: 'Quina diferència hi ha entre l\'assegurança de mercaderies i la RC del transportista?',
            a: 'L\'assegurança de mercaderies cobreix el valor de la càrrega. La RC del transportista cobreix la teva responsabilitat legal si aquesta càrrega es danya per causa teva. L\'habitual és contractar la RC, i afegir mercaderies quan el client ho demana o la càrrega és de molt valor.'
          },
          {
            q: 'Cobreix el transport internacional?',
            a: 'Sí, si contractes la modalitat CMR. Cal declarar els països pels quals circules, perquè l\'àmbit geogràfic es pacta a la pòlissa.'
          },
          {
            q: 'Podeu assegurar tota la flota en una sola pòlissa?',
            a: 'Sí. Per a flotes és l\'habitual i sol sortir més barat que assegurar vehicle a vehicle. Explica\'ns quants vehicles són i ho mirem.'
          }
        ],

        relacionados: ['flotas-camiones-tarragona', 'rc-transportista-tarragona', 'responsabilidad-civil-tarragona'],

        ctaTitulo: 'Transportes mercaderia de tercers?',
        ctaTexto:
          'Digues-nos què transportes i amb quants vehicles. Et preparem la cobertura que de veritat necessites, sense pagar pel que no fas servir.',
        ctaWhatsapp: 'Hola, vull informació sobre l\'assegurança de mercaderies'
      }
    },

    /* =====================================================================
       A PARTIR DE AQUÍ: ESQUELETOS LISTOS PARA ESCRIBIR
       -----------------------------------------------------------------------
       Cada uno lleva ya el title, la description, el H1 y las keywords
       investigadas, más el guion de H2 que debería seguir el texto.

       Están con publicada: false, así que ahora mismo NO existen como URL.
       Escribe el contenido siguiendo el modelo de "hogar-tarragona" y cambia
       a publicada: true cuando esté terminado.
       ================================================================== */

    // ---------------- PARTICULARES ----------------
    {
      slug: { es: 'coche-tarragona', ca: 'cotxe-tarragona' },
      grupo: 'particular',
      icono: 'mdi-car-outline',
      publicada: true,
      es: {
        titleSeo: 'Seguro de coche en Tarragona | Gestoría Riola',
        description:
          'Comparamos el seguro de tu coche entre varias aseguradoras. Terceros, terceros ampliado o todo riesgo: te decimos cuál te conviene. Presupuesto gratis.',
        h1: 'Contratar seguro de coche en Tarragona',
        kwPrincipal: 'seguro de coche en Tarragona',
        kwLongTail: [
          'seguro de coche barato Tarragona',
          'comparar seguros de coche Tarragona',
          'seguro a terceros ampliado Tarragona',
          'seguro de coche para conductor novel Tarragona'
        ],
        resumen: 'Terceros, terceros ampliado o todo riesgo. Comparamos y te decimos qué le conviene a tu coche.',
        entradilla:
          'Por el mismo coche y el mismo conductor, el precio cambia mucho de una compañía a otra. Pedimos presupuesto a varias con las mismas coberturas, te enseñamos la comparativa y te decimos cuál le conviene a tu coche. Sin que tengas que buscar tú.',
        guionH2: [
          'Terceros, terceros ampliado y todo riesgo: cuál te toca',
          'Cuándo deja de compensar el todo riesgo',
          'Conductor novel y conductor ocasional',
          'Qué pasa con el seguro cuando cambias de coche',
          'Lo hacemos junto con la transferencia'
        ],
        secciones: [
          {
            h2: 'Terceros, terceros ampliado y todo riesgo: cuál te toca',
            parrafos: [
              'Los nombres son tres pero lo que cambia de verdad es una cosa: quién paga los daños de tu coche. El resto de coberturas suele ser parecido.'
            ],
            lista: [
              'Terceros: cubre el daño que causas a otros. Es el mínimo obligatorio. Tu coche, si se rompe, lo pagas tú.',
              'Terceros ampliado: lo anterior más lunas, robo, incendio y daños por fenómenos atmosféricos. Es el punto medio donde acaba la mayoría.',
              'Todo riesgo: además cubre los golpes que te hagas tú, con o sin culpable. Puede ser con franquicia (pagas una parte fija de cada parte) o sin ella.'
            ],
            destacado:
              'La franquicia es el que más gente pasa por alto. Un todo riesgo con 300 euros de franquicia y otro con 600 no son el mismo producto, aunque en el papel los dos pongan "todo riesgo".'
          },
          {
            h2: 'Cuándo deja de compensar el todo riesgo',
            parrafos: [
              'A partir de cierta edad del coche la cuenta deja de salir. Si el vehículo vale 4.000 euros y el todo riesgo te cuesta 700 al año, en poco tiempo has pagado en primas más de lo que te devolverían si lo pierdes.',
              'No hay una edad exacta a la que cambiar: depende de lo que valga el coche, de lo que uses el coche y de si podrías asumir una reparación grande de golpe. Como orientación, cuando el vehículo pasa de los ocho o diez años merece la pena hacer números.',
              'Nosotros te damos el precio de las tres modalidades a la vez para que veas la diferencia real en euros, no en teoría.'
            ]
          },
          {
            h2: 'Conductor novel y conductor ocasional',
            parrafos: [
              'Si acabas de sacarte el carnet vas a pagar más, eso no lo arregla nadie. Pero la penalización por ser novel no es igual en todas las compañías, y ahí es donde comparar cambia el precio de verdad.',
              'También hay que declarar bien quién conduce. Si el coche lo lleva sobre todo tu hijo pero la póliza va a tu nombre como conductor único, la compañía puede discutir la indemnización cuando haya un parte. Es más barato declararlo desde el principio que pelearlo después.'
            ]
          },
          {
            h2: 'Qué pasa con el seguro cuando cambias de coche',
            parrafos: [
              'La póliza va ligada al vehículo, no a ti. Cuando cambias de coche no se cancela: se traslada al nuevo y se ajusta la prima. Tu historial de años sin siniestros te sigue, que es lo que de verdad te abarata el seguro con el tiempo.',
              'Si vendes el coche y no compras otro, hay que anular la póliza y reclamar la parte de prima no consumida. Se hace, pero hay que pedirlo.'
            ]
          },
          {
            h2: 'Lo hacemos junto con la transferencia',
            parrafos: [
              'Somos gestoría de vehículos desde 1935 y correduría de seguros. Cuando nos traes la compra de un coche ya tenemos delante la ficha técnica, el permiso de circulación y los datos del conductor: no hay que volver a pedirte nada para darte el presupuesto del seguro.'
            ],
            destacado:
              'Puedes salir el mismo día con el coche a tu nombre y asegurado. Un trámite, una gestión, un interlocutor.'
          }
        ],
        faqs: [
          {
            q: '¿Cuánto cuesta un seguro de coche en Tarragona?',
            a: 'Depende del coche, de la edad y el historial del conductor, de la modalidad y de dónde lo aparcas. Entre la compañía más cara y la más barata para el mismo perfil suele haber cientos de euros al año. Mándanos la matrícula y los datos del conductor y te damos precios reales de varias compañías, sin compromiso.'
          },
          {
            q: '¿Qué necesitáis para darme un presupuesto?',
            a: 'La matrícula del coche y los datos del conductor habitual: fecha de nacimiento, antigüedad del carnet y si has tenido partes en los últimos años. Con eso pedimos precio a varias aseguradoras.'
          },
          {
            q: 'Soy conductor novel, ¿me vais a poder asegurar?',
            a: 'Sí. Pagarás más que un conductor con años de carnet, pero no todas las compañías penalizan igual. Comparar es justo lo que más rebaja el precio en tu caso.'
          },
          {
            q: '¿Puedo cambiar de compañía a mitad de año?',
            a: 'Puedes, aunque lo normal es hacerlo al vencimiento para no perder prima. Hay que avisar a la compañía actual con un mes de antelación. Si nos dices cuándo te vence, nos encargamos nosotros del aviso.'
          },
          {
            q: '¿Y si tengo un accidente?',
            a: 'Nos llamas a nosotros. Tramitamos el parte, hablamos con la compañía, revisamos el peritaje y reclamamos si la valoración no es correcta. Sin coste adicional: va incluido en ser cliente nuestro.'
          }
        ],
        relacionados: ['moto-tarragona', 'hogar-tarragona', 'flotas-camiones-tarragona'],
        ctaTitulo: 'Pídenos presupuesto para tu coche',
        ctaTexto: 'Mándanos la matrícula y los datos del conductor. Te comparamos varias compañías.',
        ctaWhatsapp: 'Hola, quiero un presupuesto de seguro de coche'
      },
      ca: {
        titleSeo: 'Assegurança de cotxe a Tarragona | Gestoria Riola',
        description:
          'Comparem l\'assegurança del teu cotxe entre diverses asseguradores. Tercers, tercers ampliat o tot risc: et diem quina et convé. Pressupost gratis.',
        h1: 'Contractar assegurança de cotxe a Tarragona',
        kwPrincipal: 'assegurança de cotxe a Tarragona',
        kwLongTail: [
          'assegurança de cotxe barata Tarragona',
          'comparar assegurances de cotxe Tarragona',
          'assegurança a tercers ampliat Tarragona'
        ],
        resumen: 'Tercers, tercers ampliat o tot risc. Comparem i et diem què li convé al teu cotxe.',
        entradilla:
          'Pel mateix cotxe i el mateix conductor, el preu canvia molt d\'una companyia a una altra. Demanem pressupost a diverses amb les mateixes cobertures, t\'ensenyem la comparativa i et diem quina li convé al teu cotxe. Sense que hagis de buscar tu.',
        guionH2: [
          'Tercers, tercers ampliat i tot risc: quin et toca',
          'Quan deixa de compensar el tot risc',
          'Conductor novell i conductor ocasional',
          'Què passa amb l\'assegurança quan canvies de cotxe',
          'Ho fem juntament amb la transferència'
        ],
        secciones: [
          {
            h2: 'Tercers, tercers ampliat i tot risc: quin et toca',
            parrafos: [
              'Els noms són tres però el que canvia de debò és una cosa: qui paga els danys del teu cotxe. La resta de cobertures sol ser semblant.'
            ],
            lista: [
              'Tercers: cobreix el dany que causes a altres. És el mínim obligatori. El teu cotxe, si es trenca, el pagues tu.',
              'Tercers ampliat: l\'anterior més llunes, robatori, incendi i danys per fenòmens atmosfèrics. És el punt mig on acaba la majoria.',
              'Tot risc: a més cobreix els cops que et facis tu, amb culpable o sense. Pot ser amb franquícia (pagues una part fixa de cada comunicat) o sense.'
            ],
            destacado:
              'La franquícia és el que més gent passa per alt. Un tot risc amb 300 euros de franquícia i un altre amb 600 no són el mateix producte, encara que al paper tots dos posin "tot risc".'
          },
          {
            h2: 'Quan deixa de compensar el tot risc',
            parrafos: [
              'A partir de certa edat del cotxe el compte deixa de sortir. Si el vehicle val 4.000 euros i el tot risc et costa 700 a l\'any, en poc temps has pagat en primes més del que et tornarien si el perds.',
              'No hi ha una edat exacta per canviar: depèn del que valgui el cotxe, de com l\'utilitzis i de si podries assumir una reparació grossa de cop. Com a orientació, quan el vehicle passa dels vuit o deu anys val la pena fer números.',
              'Nosaltres et donem el preu de les tres modalitats alhora perquè vegis la diferència real en euros, no en teoria.'
            ]
          },
          {
            h2: 'Conductor novell i conductor ocasional',
            parrafos: [
              'Si acabes de treure\'t el carnet pagaràs més, això no ho arregla ningú. Però la penalització per ser novell no és igual a totes les companyies, i és aquí on comparar canvia el preu de debò.',
              'També cal declarar bé qui condueix. Si el cotxe el porta sobretot el teu fill però la pòlissa va al teu nom com a conductor únic, la companyia pot discutir la indemnització quan hi hagi un comunicat. Surt més barat declarar-ho des del principi que barallar-ho després.'
            ]
          },
          {
            h2: 'Què passa amb l\'assegurança quan canvies de cotxe',
            parrafos: [
              'La pòlissa va lligada al vehicle, no a tu. Quan canvies de cotxe no es cancel·la: es trasllada al nou i s\'ajusta la prima. El teu historial d\'anys sense sinistres et segueix, que és el que de debò t\'abarateix l\'assegurança amb el temps.',
              'Si véns el cotxe i no en compres cap altre, cal anul·lar la pòlissa i reclamar la part de prima no consumida. Es fa, però s\'ha de demanar.'
            ]
          },
          {
            h2: 'Ho fem juntament amb la transferència',
            parrafos: [
              'Som gestoria de vehicles des del 1935 i corredoria d\'assegurances. Quan ens portes la compra d\'un cotxe ja tenim al davant la fitxa tècnica, el permís de circulació i les dades del conductor: no cal tornar-te a demanar res per donar-te el pressupost de l\'assegurança.'
            ],
            destacado:
              'Pots sortir el mateix dia amb el cotxe al teu nom i assegurat. Un tràmit, una gestió, un interlocutor.'
          }
        ],
        faqs: [
          {
            q: 'Quant costa una assegurança de cotxe a Tarragona?',
            a: 'Depèn del cotxe, de l\'edat i l\'historial del conductor, de la modalitat i d\'on l\'aparques. Entre la companyia més cara i la més barata per al mateix perfil sol haver-hi centenars d\'euros a l\'any. Envia\'ns la matrícula i les dades del conductor i et donem preus reals de diverses companyies, sense compromís.'
          },
          {
            q: 'Què necessiteu per donar-me un pressupost?',
            a: 'La matrícula del cotxe i les dades del conductor habitual: data de naixement, antiguitat del carnet i si has tingut comunicats els últims anys. Amb això demanem preu a diverses asseguradores.'
          },
          {
            q: 'Sóc conductor novell, em podreu assegurar?',
            a: 'Sí. Pagaràs més que un conductor amb anys de carnet, però no totes les companyies penalitzen igual. Comparar és justament el que més rebaixa el preu en el teu cas.'
          },
          {
            q: 'Puc canviar de companyia a mitja anualitat?',
            a: 'Pots, tot i que el normal és fer-ho al venciment per no perdre prima. Cal avisar la companyia actual amb un mes d\'antelació. Si ens dius quan et venç, ens n\'encarreguem nosaltres.'
          },
          {
            q: 'I si tinc un accident?',
            a: 'Ens truques a nosaltres. Tramitem el comunicat, parlem amb la companyia, revisem el peritatge i reclamem si la valoració no és correcta. Sense cost addicional: va inclòs en ser client nostre.'
          }
        ],
        relacionados: ['moto-tarragona', 'hogar-tarragona', 'flotas-camiones-tarragona'],
        ctaTitulo: 'Demana\'ns pressupost per al teu cotxe',
        ctaTexto: 'Envia\'ns la matrícula i les dades del conductor. Et comparem diverses companyies.',
        ctaWhatsapp: 'Hola, vull un pressupost d\'assegurança de cotxe'
      }
    },

    {
      slug: { es: 'moto-tarragona', ca: 'moto-tarragona' },
      grupo: 'particular',
      icono: 'mdi-motorbike',
      publicada: false,
      es: {
        titleSeo: 'Seguro de moto en Tarragona | Gestoría Riola',
        description:
          'Seguro de moto y ciclomotor en Tarragona. Comparamos varias compañías y miramos bien las coberturas de ocupantes y casco. Presupuesto sin compromiso.',
        h1: 'Contratar seguro de moto en Tarragona',
        kwPrincipal: 'seguro de moto en Tarragona',
        kwLongTail: [
          'seguro de moto barato Tarragona',
          'seguro de ciclomotor Tarragona',
          'seguro de moto para carnet A2 Tarragona'
        ],
        resumen: 'Moto, ciclomotor y scooter. Miramos las coberturas que de verdad importan en dos ruedas.',
        entradilla: '',
        guionH2: [
          'Qué cambia respecto al seguro de coche',
          'Cobertura de ocupantes, casco y equipación',
          'Motos aparcadas en la calle: robo y vandalismo',
          'Ciclomotores y vehículos de movilidad personal'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['coche-tarragona', 'vida-tarragona'],
        ctaTitulo: 'Pídenos presupuesto para tu moto',
        ctaTexto: 'Dinos la matrícula, la cilindrada y dónde la aparcas.',
        ctaWhatsapp: 'Hola, quiero un presupuesto de seguro de moto'
      },
      ca: {
        titleSeo: 'Assegurança de moto a Tarragona | Gestoria Riola',
        description:
          'Assegurança de moto i ciclomotor a Tarragona. Comparem diverses companyies i mirem bé les cobertures d\'ocupants i casc. Pressupost sense compromís.',
        h1: 'Contractar assegurança de moto a Tarragona',
        kwPrincipal: 'assegurança de moto a Tarragona',
        kwLongTail: [
          'assegurança de moto barata Tarragona',
          'assegurança de ciclomotor Tarragona'
        ],
        resumen: 'Moto, ciclomotor i escúter. Mirem les cobertures que de veritat importen en dues rodes.',
        entradilla: '',
        guionH2: [
          'Què canvia respecte a l\'assegurança de cotxe',
          'Cobertura d\'ocupants, casc i equipació',
          'Motos aparcades al carrer: robatori i vandalisme',
          'Ciclomotors i vehicles de mobilitat personal'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['coche-tarragona', 'vida-tarragona'],
        ctaTitulo: 'Demana\'ns pressupost per a la teva moto',
        ctaTexto: 'Digues-nos la matrícula, la cilindrada i on l\'aparques.',
        ctaWhatsapp: 'Hola, vull un pressupost d\'assegurança de moto'
      }
    },

    {
      slug: { es: 'vida-tarragona', ca: 'vida-tarragona' },
      grupo: 'particular',
      icono: 'mdi-heart-pulse',
      publicada: false,
      es: {
        titleSeo: 'Seguro de vida en Tarragona | Gestoría Riola',
        description:
          'Seguro de vida vinculado a hipoteca o independiente. Te explicamos qué cubre, qué excluye y por qué no tienes que contratarlo con el banco.',
        h1: 'Contratar seguro de vida en Tarragona',
        kwPrincipal: 'seguro de vida en Tarragona',
        kwLongTail: [
          'seguro de vida para hipoteca Tarragona',
          'cambiar seguro de vida del banco Tarragona',
          'seguro de vida e invalidez Tarragona'
        ],
        resumen: 'Sobre todo si lo tienes vinculado a la hipoteca: no estás obligado a contratarlo con el banco.',
        entradilla: '',
        guionH2: [
          'Fallecimiento e invalidez: no son lo mismo',
          'El seguro de vida vinculado a la hipoteca',
          'Puedes cambiarlo de compañía y seguir cumpliendo con el banco',
          'El cuestionario de salud: por qué hay que rellenarlo bien',
          'Cómo se calcula el capital que necesitas'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['hogar-tarragona', 'salud-tarragona', 'decesos-tarragona'],
        ctaTitulo: '¿Tienes el seguro de vida con el banco?',
        ctaTexto: 'Mándanos la póliza y te decimos cuánto te ahorrarías cambiándolo.',
        ctaWhatsapp: 'Hola, quiero información sobre el seguro de vida'
      },
      ca: {
        titleSeo: 'Assegurança de vida a Tarragona | Gestoria Riola',
        description:
          'Assegurança de vida vinculada a hipoteca o independent. T\'expliquem què cobreix, què exclou i per què no l\'has de contractar amb el banc.',
        h1: 'Contractar assegurança de vida a Tarragona',
        kwPrincipal: 'assegurança de vida a Tarragona',
        kwLongTail: [
          'assegurança de vida per a hipoteca Tarragona',
          'canviar assegurança de vida del banc Tarragona'
        ],
        resumen: 'Sobretot si la tens vinculada a la hipoteca: no estàs obligat a contractar-la amb el banc.',
        entradilla: '',
        guionH2: [
          'Defunció i invalidesa: no són el mateix',
          'L\'assegurança de vida vinculada a la hipoteca',
          'La pots canviar de companyia i seguir complint amb el banc',
          'El qüestionari de salut: per què cal omplir-lo bé',
          'Com es calcula el capital que necessites'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['hogar-tarragona', 'salud-tarragona', 'decesos-tarragona'],
        ctaTitulo: 'Tens l\'assegurança de vida amb el banc?',
        ctaTexto: 'Envia\'ns la pòlissa i et diem quant estalviaries canviant-la.',
        ctaWhatsapp: 'Hola, vull informació sobre l\'assegurança de vida'
      }
    },

    {
      slug: { es: 'salud-tarragona', ca: 'salut-tarragona' },
      grupo: 'particular',
      icono: 'mdi-medical-bag',
      publicada: false,
      es: {
        titleSeo: 'Seguro de salud en Tarragona | Gestoría Riola',
        description:
          'Seguro médico privado en Tarragona: con o sin copago, cuadro médico y carencias. Comparamos compañías y te explicamos la letra pequeña.',
        h1: 'Contratar seguro de salud en Tarragona',
        kwPrincipal: 'seguro de salud en Tarragona',
        kwLongTail: [
          'seguro médico privado Tarragona',
          'seguro de salud sin copago Tarragona',
          'seguro de salud familiar Tarragona',
          'seguro de salud para autónomos Tarragona'
        ],
        resumen: 'Con copago o sin copago, cuadro médico y carencias. Las tres cosas que deciden si te sirve.',
        entradilla: '',
        guionH2: [
          'Con copago o sin copago: cuál sale a cuenta',
          'El cuadro médico en Tarragona es lo primero que hay que mirar',
          'Carencias: lo que no te cubren el primer año',
          'Preexistencias y cuestionario de salud',
          'Si eres autónomo, es gasto deducible'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['vida-tarragona', 'decesos-tarragona'],
        ctaTitulo: 'Compara tu seguro de salud',
        ctaTexto: 'Dinos cuántos sois y qué edades. Te mandamos las opciones con el cuadro médico de Tarragona.',
        ctaWhatsapp: 'Hola, quiero información sobre el seguro de salud'
      },
      ca: {
        titleSeo: 'Assegurança de salut a Tarragona | Gestoria Riola',
        description:
          'Assegurança mèdica privada a Tarragona: amb o sense copagament, quadre mèdic i carències. Comparem companyies i t\'expliquem la lletra petita.',
        h1: 'Contractar assegurança de salut a Tarragona',
        kwPrincipal: 'assegurança de salut a Tarragona',
        kwLongTail: [
          'assegurança mèdica privada Tarragona',
          'assegurança de salut sense copagament Tarragona',
          'assegurança de salut familiar Tarragona'
        ],
        resumen: 'Amb copagament o sense, quadre mèdic i carències. Les tres coses que decideixen si et serveix.',
        entradilla: '',
        guionH2: [
          'Amb copagament o sense: quin surt a compte',
          'El quadre mèdic a Tarragona és el primer que cal mirar',
          'Carències: el que no et cobreixen el primer any',
          'Preexistències i qüestionari de salut',
          'Si ets autònom, és despesa deduïble'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['vida-tarragona', 'decesos-tarragona'],
        ctaTitulo: 'Compara la teva assegurança de salut',
        ctaTexto: 'Digues-nos quants sou i quines edats. T\'enviem les opcions amb el quadre mèdic de Tarragona.',
        ctaWhatsapp: 'Hola, vull informació sobre l\'assegurança de salut'
      }
    },

    {
      slug: { es: 'decesos-tarragona', ca: 'decessos-tarragona' },
      grupo: 'particular',
      icono: 'mdi-flower-outline',
      publicada: false,
      es: {
        titleSeo: 'Seguro de decesos en Tarragona | Gestoría Riola',
        description:
          'Seguro de decesos en Tarragona con la tramitación resuelta. Te explicamos qué incluye, qué modalidades hay y qué cubre además del servicio funerario.',
        h1: 'Contratar seguro de decesos en Tarragona',
        kwPrincipal: 'seguro de decesos en Tarragona',
        kwLongTail: [
          'seguro de decesos precio Tarragona',
          'seguro de decesos para mayores Tarragona',
          'cambiar seguro de decesos Tarragona'
        ],
        resumen: 'Además del servicio funerario, incluye la tramitación de la herencia y del papeleo. Eso es lo que más se agradece.',
        entradilla: '',
        guionH2: [
          'Qué incluye más allá del servicio funerario',
          'Prima nivelada, natural o única: la diferencia importa mucho',
          'Se puede cambiar de compañía sin perder lo pagado',
          'La parte de tramitación: certificados, herencia y bajas'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['vida-tarragona', 'salud-tarragona'],
        ctaTitulo: 'Infórmate sin compromiso',
        ctaTexto: 'Es un tema incómodo de tratar. Lo hablamos con calma y sin presión.',
        ctaWhatsapp: 'Hola, quiero información sobre el seguro de decesos'
      },
      ca: {
        titleSeo: 'Assegurança de decessos a Tarragona | Gestoria Riola',
        description:
          'Assegurança de decessos a Tarragona amb la tramitació resolta. T\'expliquem què inclou, quines modalitats hi ha i què cobreix a més del servei funerari.',
        h1: 'Contractar assegurança de decessos a Tarragona',
        kwPrincipal: 'assegurança de decessos a Tarragona',
        kwLongTail: [
          'assegurança de decessos preu Tarragona',
          'assegurança de decessos per a grans Tarragona'
        ],
        resumen: 'A més del servei funerari, inclou la tramitació de l\'herència i del paperam. Això és el que més s\'agraeix.',
        entradilla: '',
        guionH2: [
          'Què inclou més enllà del servei funerari',
          'Prima anivellada, natural o única: la diferència importa molt',
          'Es pot canviar de companyia sense perdre el que s\'ha pagat',
          'La part de tramitació: certificats, herència i baixes'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['vida-tarragona', 'salud-tarragona'],
        ctaTitulo: 'Informa\'t sense compromís',
        ctaTexto: 'És un tema incòmode de tractar. En parlem amb calma i sense pressió.',
        ctaWhatsapp: 'Hola, vull informació sobre l\'assegurança de decessos'
      }
    },

    // ---------------- AUTÓNOMOS Y EMPRESA ----------------
    {
      slug: { es: 'responsabilidad-civil-tarragona', ca: 'responsabilitat-civil-tarragona' },
      grupo: 'empresa',
      icono: 'mdi-scale-balance',
      publicada: false,
      es: {
        titleSeo: 'Seguro de responsabilidad civil en Tarragona | Gestoría Riola',
        description:
          'Seguro de RC para autónomos y empresas en Tarragona. Te explicamos qué límite necesitas según tu actividad y qué exclusiones tienes que mirar.',
        h1: 'Seguro de responsabilidad civil para empresas y autónomos en Tarragona',
        kwPrincipal: 'seguro de responsabilidad civil Tarragona',
        kwLongTail: [
          'seguro de responsabilidad civil para autónomos Tarragona',
          'seguro RC profesional Tarragona',
          'seguro responsabilidad civil empresa Tarragona',
          'RC obligatoria para licencia de actividad Tarragona'
        ],
        resumen: 'La póliza que te piden para la licencia de actividad y la que te salva si un cliente reclama.',
        entradilla: '',
        guionH2: [
          'RC de explotación, patronal y de producto: qué cubre cada una',
          'Qué límite necesitas según tu actividad',
          'La RC que exige el ayuntamiento para la licencia de actividad',
          'Reclamaciones posteriores al cese de la actividad',
          'Exclusiones que hay que mirar antes de firmar'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['multirriesgo-comercio-tarragona', 'convenio-tarragona', 'rc-transportista-tarragona'],
        ctaTitulo: '¿Te han pedido una póliza de RC?',
        ctaTexto: 'Dinos qué actividad tienes y qué límite te exigen. Te lo preparamos.',
        ctaWhatsapp: 'Hola, necesito un seguro de responsabilidad civil'
      },
      ca: {
        titleSeo: 'Assegurança de responsabilitat civil a Tarragona | Gestoria Riola',
        description:
          'Assegurança de RC per a autònoms i empreses a Tarragona. T\'expliquem quin límit necessites segons la teva activitat i quines exclusions has de mirar.',
        h1: 'Assegurança de responsabilitat civil per a empreses i autònoms a Tarragona',
        kwPrincipal: 'assegurança de responsabilitat civil Tarragona',
        kwLongTail: [
          'assegurança de responsabilitat civil per a autònoms Tarragona',
          'assegurança RC professional Tarragona',
          'RC obligatòria per a llicència d\'activitat Tarragona'
        ],
        resumen: 'La pòlissa que et demanen per a la llicència d\'activitat i la que et salva si un client reclama.',
        entradilla: '',
        guionH2: [
          'RC d\'explotació, patronal i de producte: què cobreix cadascuna',
          'Quin límit necessites segons la teva activitat',
          'La RC que exigeix l\'ajuntament per a la llicència d\'activitat',
          'Reclamacions posteriors al cessament de l\'activitat',
          'Exclusions que cal mirar abans de signar'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['multirriesgo-comercio-tarragona', 'convenio-tarragona', 'rc-transportista-tarragona'],
        ctaTitulo: 'T\'han demanat una pòlissa de RC?',
        ctaTexto: 'Digues-nos quina activitat tens i quin límit t\'exigeixen. T\'ho preparem.',
        ctaWhatsapp: 'Hola, necessito una assegurança de responsabilitat civil'
      }
    },

    {
      slug: { es: 'multirriesgo-comercio-tarragona', ca: 'multirisc-comerc-tarragona' },
      grupo: 'empresa',
      icono: 'mdi-storefront-outline',
      publicada: false,
      es: {
        titleSeo: 'Seguro multirriesgo de comercio en Tarragona | Gestoría Riola',
        description:
          'Protege tu local, tu género y tu facturación. Seguro multirriesgo para comercios, oficinas y talleres en Tarragona. Presupuesto sin compromiso.',
        h1: 'Seguro multirriesgo de comercio en Tarragona',
        kwPrincipal: 'seguro multirriesgo comercio Tarragona',
        kwLongTail: [
          'seguro para local comercial Tarragona',
          'seguro de negocio Tarragona',
          'seguro para taller Tarragona',
          'seguro de oficina Tarragona'
        ],
        resumen: 'El local, el género, la maquinaria y lo que dejas de facturar si tienes que cerrar.',
        entradilla: '',
        guionH2: [
          'Qué se asegura en un local: continente, contenido y existencias',
          'Pérdida de beneficios: lo que dejas de ganar si cierras',
          'Robo, expoliación y daños por agua',
          'Si el local es de alquiler, qué te toca a ti y qué al propietario',
          'Talleres y actividades con maquinaria'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['responsabilidad-civil-tarragona', 'convenio-tarragona'],
        ctaTitulo: 'Asegura tu negocio como toca',
        ctaTexto: 'Dinos la actividad, los metros del local y el valor del género.',
        ctaWhatsapp: 'Hola, quiero un seguro para mi negocio'
      },
      ca: {
        titleSeo: 'Assegurança multirisc de comerç a Tarragona | Gestoria Riola',
        description:
          'Protegeix el teu local, el teu gènere i la teva facturació. Assegurança multirisc per a comerços, oficines i tallers a Tarragona. Pressupost sense compromís.',
        h1: 'Assegurança multirisc de comerç a Tarragona',
        kwPrincipal: 'assegurança multirisc comerç Tarragona',
        kwLongTail: [
          'assegurança per a local comercial Tarragona',
          'assegurança de negoci Tarragona',
          'assegurança per a taller Tarragona'
        ],
        resumen: 'El local, el gènere, la maquinària i el que deixes de facturar si has de tancar.',
        entradilla: '',
        guionH2: [
          'Què s\'assegura en un local: continent, contingut i existències',
          'Pèrdua de beneficis: el que deixes de guanyar si tanques',
          'Robatori, espoliació i danys per aigua',
          'Si el local és de lloguer, què et toca a tu i què al propietari',
          'Tallers i activitats amb maquinària'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['responsabilidad-civil-tarragona', 'convenio-tarragona'],
        ctaTitulo: 'Assegura el teu negoci com toca',
        ctaTexto: 'Digues-nos l\'activitat, els metres del local i el valor del gènere.',
        ctaWhatsapp: 'Hola, vull una assegurança per al meu negoci'
      }
    },

    {
      slug: { es: 'convenio-tarragona', ca: 'conveni-tarragona' },
      grupo: 'empresa',
      icono: 'mdi-account-hard-hat',
      publicada: false,
      es: {
        titleSeo: 'Seguro de convenio colectivo en Tarragona | Gestoría Riola',
        description:
          'El seguro de convenio es obligatorio y las sanciones por no tenerlo son altas. Te decimos qué te exige tu convenio en Tarragona y te lo contratamos.',
        h1: 'Seguro de convenio colectivo en Tarragona',
        kwPrincipal: 'seguro de convenio Tarragona',
        kwLongTail: [
          'seguro de convenio colectivo obligatorio Tarragona',
          'seguro convenio construcción Tarragona',
          'seguro convenio transporte Tarragona',
          'sanción por no tener seguro de convenio'
        ],
        resumen: 'Es obligatorio si tienes trabajadores y tu convenio lo exige. Y las sanciones por no tenerlo son caras.',
        entradilla: '',
        guionH2: [
          'Qué es y por qué es obligatorio',
          'Cómo saber qué capital exige tu convenio',
          'Qué pasa si tienes un accidente laboral y no lo tienes contratado',
          'Convenios más habituales en Tarragona: transporte, construcción, hostelería',
          'Se actualiza cada vez que cambia el convenio'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['responsabilidad-civil-tarragona', 'multirriesgo-comercio-tarragona'],
        ctaTitulo: '¿Tienes trabajadores en plantilla?',
        ctaTexto: 'Dinos tu convenio y te decimos qué capital te exige y cuánto cuesta cubrirlo.',
        ctaWhatsapp: 'Hola, necesito el seguro de convenio para mis trabajadores'
      },
      ca: {
        titleSeo: 'Assegurança de conveni col·lectiu a Tarragona | Gestoria Riola',
        description:
          'L\'assegurança de conveni és obligatòria i les sancions per no tenir-la són altes. Et diem què t\'exigeix el teu conveni a Tarragona i te la contractem.',
        h1: 'Assegurança de conveni col·lectiu a Tarragona',
        kwPrincipal: 'assegurança de conveni Tarragona',
        kwLongTail: [
          'assegurança de conveni col·lectiu obligatòria Tarragona',
          'assegurança conveni construcció Tarragona',
          'assegurança conveni transport Tarragona'
        ],
        resumen: 'És obligatòria si tens treballadors i el teu conveni ho exigeix. I les sancions per no tenir-la són cares.',
        entradilla: '',
        guionH2: [
          'Què és i per què és obligatòria',
          'Com saber quin capital exigeix el teu conveni',
          'Què passa si tens un accident laboral i no la tens contractada',
          'Convenis més habituals a Tarragona: transport, construcció, hostaleria',
          'S\'actualitza cada cop que canvia el conveni'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['responsabilidad-civil-tarragona', 'multirriesgo-comercio-tarragona'],
        ctaTitulo: 'Tens treballadors a plantilla?',
        ctaTexto: 'Digues-nos el teu conveni i et diem quin capital t\'exigeix i quant costa cobrir-lo.',
        ctaWhatsapp: 'Hola, necessito l\'assegurança de conveni per als meus treballadors'
      }
    },

    // ---------------- TRANSPORTE ----------------
    {
      slug: { es: 'flotas-camiones-tarragona', ca: 'flotes-camions-tarragona' },
      grupo: 'transporte',
      icono: 'mdi-truck-outline',
      publicada: false,
      es: {
        titleSeo: 'Seguro de flotas de camiones en Tarragona | Gestoría Riola',
        description:
          'Seguro de flota para empresas de transporte en Tarragona. Una sola póliza para todos los vehículos, con altas y bajas ágiles. Presupuesto a medida.',
        h1: 'Seguro de flotas de camiones en Tarragona',
        kwPrincipal: 'seguro de flotas Tarragona',
        kwLongTail: [
          'seguro de flota de camiones Tarragona',
          'seguro para empresa de transporte Tarragona',
          'seguro flota furgonetas Tarragona',
          'póliza flota vehículos industriales Tarragona'
        ],
        resumen: 'Una sola póliza para toda la flota, con altas y bajas el mismo día. Y nosotros ya llevamos vuestras tarjetas.',
        entradilla: '',
        guionH2: [
          'A partir de cuántos vehículos compensa una póliza de flota',
          'Altas y bajas de vehículos sin renegociar la póliza entera',
          'Cabezas tractoras, semirremolques y vehículos de apoyo',
          'Siniestralidad: cómo afecta al precio de la renovación',
          'Lo llevamos junto con las tarjetas de transporte'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['mercancias-tarragona', 'rc-transportista-tarragona', 'convenio-tarragona'],
        ctaTitulo: '¿Cuántos vehículos tienes?',
        ctaTexto: 'Mándanos el listado de matrículas y la siniestralidad de los últimos años. Te preparamos la comparativa.',
        ctaWhatsapp: 'Hola, quiero un presupuesto para el seguro de mi flota'
      },
      ca: {
        titleSeo: 'Assegurança de flotes de camions a Tarragona | Gestoria Riola',
        description:
          'Assegurança de flota per a empreses de transport a Tarragona. Una sola pòlissa per a tots els vehicles, amb altes i baixes àgils. Pressupost a mida.',
        h1: 'Assegurança de flotes de camions a Tarragona',
        kwPrincipal: 'assegurança de flotes Tarragona',
        kwLongTail: [
          'assegurança de flota de camions Tarragona',
          'assegurança per a empresa de transport Tarragona',
          'assegurança flota furgonetes Tarragona'
        ],
        resumen: 'Una sola pòlissa per a tota la flota, amb altes i baixes el mateix dia. I nosaltres ja portem les vostres targetes.',
        entradilla: '',
        guionH2: [
          'A partir de quants vehicles compensa una pòlissa de flota',
          'Altes i baixes de vehicles sense renegociar la pòlissa sencera',
          'Caps tractors, semiremolcs i vehicles de suport',
          'Sinistralitat: com afecta el preu de la renovació',
          'Ho portem juntament amb les targetes de transport'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['mercancias-tarragona', 'rc-transportista-tarragona', 'convenio-tarragona'],
        ctaTitulo: 'Quants vehicles tens?',
        ctaTexto: 'Envia\'ns el llistat de matrícules i la sinistralitat dels últims anys. Et preparem la comparativa.',
        ctaWhatsapp: 'Hola, vull un pressupost per a l\'assegurança de la meva flota'
      }
    },

    {
      slug: { es: 'rc-transportista-tarragona', ca: 'rc-transportista-tarragona' },
      grupo: 'transporte',
      icono: 'mdi-clipboard-check-outline',
      publicada: false,
      es: {
        titleSeo: 'Seguro de RC del transportista en Tarragona | Gestoría Riola',
        description:
          'Responsabilidad civil del transportista en Tarragona: nacional y CMR internacional. Te explicamos los límites legales y cuándo se quedan cortos.',
        h1: 'Seguro de responsabilidad civil del transportista en Tarragona',
        kwPrincipal: 'RC transportista Tarragona',
        kwLongTail: [
          'seguro responsabilidad civil transportista Tarragona',
          'seguro CMR Tarragona',
          'RC porteador transporte nacional',
          'seguro obligatorio transportista autónomo Tarragona'
        ],
        resumen: 'Tu responsabilidad como porteador. Lo que te reclaman a ti cuando la carga se daña o se pierde.',
        entradilla: '',
        guionH2: [
          'Qué es la responsabilidad del porteador',
          'Límites legales: LCTTM en nacional, CMR en internacional',
          'Cuándo el límite legal se queda corto y necesitas valor declarado',
          'Carga y descarga: quién responde en cada momento',
          'Documentación que te van a pedir tus cargadores'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['mercancias-tarragona', 'flotas-camiones-tarragona'],
        ctaTitulo: '¿Te piden certificado de RC para darte carga?',
        ctaTexto: 'Te lo preparamos con los límites que te exija el cargador.',
        ctaWhatsapp: 'Hola, necesito el seguro de RC del transportista'
      },
      ca: {
        titleSeo: 'Assegurança de RC del transportista a Tarragona | Gestoria Riola',
        description:
          'Responsabilitat civil del transportista a Tarragona: nacional i CMR internacional. T\'expliquem els límits legals i quan es queden curts.',
        h1: 'Assegurança de responsabilitat civil del transportista a Tarragona',
        kwPrincipal: 'RC transportista Tarragona',
        kwLongTail: [
          'assegurança responsabilitat civil transportista Tarragona',
          'assegurança CMR Tarragona',
          'RC portador transport nacional'
        ],
        resumen: 'La teva responsabilitat com a portador. El que et reclamen a tu quan la càrrega es danya o es perd.',
        entradilla: '',
        guionH2: [
          'Què és la responsabilitat del portador',
          'Límits legals: LCTTM en nacional, CMR en internacional',
          'Quan el límit legal es queda curt i necessites valor declarat',
          'Càrrega i descàrrega: qui respon en cada moment',
          'Documentació que et demanaran els teus carregadors'
        ],
        secciones: [],
        faqs: [],
        relacionados: ['mercancias-tarragona', 'flotas-camiones-tarragona'],
        ctaTitulo: 'Et demanen certificat de RC per donar-te càrrega?',
        ctaTexto: 'Te\'l preparem amb els límits que t\'exigeixi el carregador.',
        ctaWhatsapp: 'Hola, necessito l\'assegurança de RC del transportista'
      }
    }
  ]
};
